export default {
  groups: {
    dashboards: 'Paneles',
    online_shop: 'Tienda en línea',
    home: 'Inicio',
    marketing: 'Marketing',
    reservations: 'Reservas',
    website: 'Sitio web',
    orders_portal: 'Abrir portal de pedidos',
    roi: 'ROI',
    google_ads: 'Google Ads',
    mobile_app: 'Aplicación móvil',
    phone_answering: 'Atención telefónica',
    pricing: 'Precios',
    team: 'Equipo',
    data_deletion_requests: 'Solicitudes de eliminación de datos',
    partner: 'Partner',
  },
  get_started: {
    title: 'Comenzar',
  },
  onboarding: {
    title: 'Lanzamiento',
  },
  new_restaurant: {
    title: 'Nuevo restaurante',
  },
  gift_cards: {
    title: 'Tarjetas de regalo',
  },
  top_items: {
    title: 'Más vendidos',
  },
  dashboards: {
    title: 'Paneles',
    children: {
      general: 'General',
      restaurant_details: 'Detalles del restaurante',
      external_delivery: 'Entrega externa',
      overview: 'Resumen',
      orders: 'Pedidos por fuente',
      google: 'Google',
      customers: 'Clientes',
    },
  },
  customer_base: {
    title: 'Base de clientes',
  },
  new_company: {
    title: 'Nuevo restaurante',
  },
  agent_ops_queue: {
    title: 'Sugerencias de IA',
  },
  external_delivery_support: {
    title: 'Soporte de entrega externa',
  },
  payment_gateways: {
    title: 'Pasarelas de pago',
  },
  developers: {
    title: 'Desarrolladores',
  },
  feature_flags: {
    title: 'Indicadores de función',
  },
  test_restaurants: {
    title: 'Restaurantes de prueba',
  },
  partners: {
    title: 'Socios',
  },
  partner: {
    children: {
      account: 'Cuenta',
      branding: 'Marca',
      payment_gateway: 'Pasarela de pago',
      billing: 'Facturación',
      tax_currency: 'Impuestos y moneda',
      service_fee_calculator: 'Calculadora de tarifa de servicio',
      processing_fees: 'Comisiones de procesamiento',
    },
  },
  going_live: {
    title: 'Puesta en marcha',
    children: {
      setup_package_fulfillments: 'Pedidos de Logsta',
      polygraphy: 'Productos impresos',
    },
  },
  franchises: {
    title: 'Marcas',
  },
  setup_package_fulfillments: {
    title: 'Gestión de paquetes de configuración',
  },
  website: {
    title: 'Sitio web',
    children: {
      storefront: 'Tienda',
      studio: 'Studio (V1)',
      studio_v2: 'Studio (V2)',
    },
  },
  reservations: {
    title: 'Reserva',
    children: {
      overview: 'Resumen',
      booking_availability: 'Disponibilidad de reservas',
      settings: 'Configuración',
      general: 'General',
      storefront: 'Tienda',
    },
  },
  subscriptions: {
    title: 'Suscripciones',
    children: {
      subscriptions: 'Suscripciones',
      products: 'Productos',
    },
  },
  sales: {
    title: 'Ventas',
    children: {
      orders: 'Pedidos',
      receipts: 'Recibos de clientes',
      external_deliveries: 'Entregas externas',
    },
  },
  billing: {
    title: 'Informes',
    children: {
      monthly_statements: 'Extractos mensuales',
      payouts: 'Pagos',
      invoices: 'Facturas',
      subscription: 'Suscripción',
      sales_summary: 'Resumen de ventas',
      internal_invoice_items: 'Conceptos internos de factura',
      income_reports: 'Informes de ingresos',
      tax_reports: 'Informes fiscales',
    },
  },
  master_menu: {
    title: 'Sincronización de marca',
  },
  menu: {
    title: 'Menú',
    children: {
      master_overview: 'Marcas',
      manage_menus: 'Gestionar menús',
      modifiers: 'Modificadores',
      smart_pricing: 'Precios inteligentes',
      upsell_items: 'Ventas adicionales',
      sold_out_items: 'Artículos agotados',
      import: 'Importar',
      edit_history: 'Historial de edición',
    },
  },
  my_store: {
    title: 'Mi información',
    children: {
      settings: 'Perfil',
      gallery: 'Galería',
      business_information: 'Información del negocio',
      documents: 'Mis documentos',
      personal_information: 'Información personal',
      bank_info: 'Datos bancarios',
      tax_info: 'Datos fiscales',
      shipping_info: 'Datos de envío',
      google_profile: 'Perfil de Google',
      seo: 'SEO',
      impressum: 'Impressum',
      imprint: 'Aviso legal',
      post_launch: 'Post-lanzamiento',
      tax_currency: 'Impuestos y moneda',
    },
  },
  opening_hours: {
    title: 'Horario y ubicación',
    children: {
      opening_hours: 'Horario de apertura',
      location: 'Ubicación',
    },
  },
  order_settings: {
    title: 'Configuración de pedidos',
    children: {
      takeout: 'Métodos de pedido',
      order_layout: 'Diseño de pedidos',
      payment_methods: 'Métodos de pago',
      connect_paypal: 'Conectar PayPal',
      tips: 'Propinas',
      service_fee: 'Tarifas',
      processing_fees: 'Comisiones de procesamiento',
      receipt: 'Recibo',
      staff_credentials: 'Credenciales del personal',
      integrations: 'Integraciones',
      terminal: 'Terminal',
      invoices: 'Facturas',
    },
  },
  mobile_app: {
    title: 'Aplicación móvil',
    children: {
      overview: 'Resumen',
      updates: 'Actualizaciones',
      intro_screen: 'Pantalla de inicio',
    },
  },
  marketing: {
    children: {
      overview: 'Resumen',
      followers: 'Seguidores',
      email_messages: 'Mensajes de correo',
      push_notifications: 'Notificaciones push',
      promo_codes: 'Códigos promocionales',
      offers: 'Ofertas',
      google_business: 'Google Business',
      google_review_program: 'Programa de reseñas de Google',
      loyalty_program: 'Programa de fidelización',
      polygraphy: 'Productos impresos',
      tracking_links: 'Enlaces de seguimiento',
      google_ads: 'Google Ads',
      website_analytics: 'Analíticas web',
      featured_posts: 'Publicaciones App Móvil',
    },
  },
  loyalty_tablet: {
    title: 'Tablet de fidelización',
    children: {
      dashboard: 'Panel',
      settings: 'Configuración',
      credentials: 'Credenciales',
    },
  },
  contract: {
    title: 'Contrato',
    children: {
      agreement: 'Acuerdo',
      template: 'Plantilla',
    },
  },
  team: {
    children: {
      managers: 'Gestores',
      reports: 'Informes',
    },
  },
};
